export default {
  list: {
    title: "Liste des livreurs",
    namePh: "Nom du livreur",
    telPh: "Téléphone",
    name: "Nom",
    tel: "Téléphone",
  },
  auth: {
    title: "Vérification",
    addRider: "Ajouter un livreur",
    batchPass: "Valider en lot",
    batchReject: "Refuser en lot",
    status: "Statut",
    allStatus: "Tous",
    pendingReview: "En attente",
    idCard: "N° ID",
    authStatus: "Certification",
    bindPhone: "Téléphone lié",
    authReject: "Refusé",
    telPh: "Téléphone livreur",
  },
  prize: {
    title: "Récompenses / sanctions",
    rewardSet: "Récompenses",
    punishSet: "Sanctions",
    add: "Ajouter",
    riderId: "ID livreur",
    punishType: "Type",
    reward: "Récompense",
    punish: "Sanction",
    category: "Catégorie",
    changeBalance: "Solde",
    noticeWarn: "Avertissement",
    forbidOrder: "Interdiction",
    freezeAccount: "Gel du compte",
    amount: "Montant",
    reason: "Motif",
    appealing: "Contesté",
    executing: "En cours",
    revoked: "Révoqué",
  },
  level: {
    title: "Niveaux livreurs",
    addLevel: "Ajouter un niveau",
    levelName: "Niveau",
    levelTitle: "Nom du niveau",
    levelSetting: "Configuration du niveau",
    levelIcon: "Icône",
    levelNamePh: "Saisir le nom du niveau",
    dailyMerge: "Fusion / jour",
    dailyMergePh: "Commandes fusionnées / jour",
    dailyTransfer: "Transfert / jour",
    dailyTransferPh: "Transferts / jour",
    dailyCancel: "Annulation / jour",
    dailyCancelPh: "Annulations / jour",
    commissionRatio: "Commission (%)",
    commissionRatioPh: "Saisir le pourcentage",
    upgradeCondition: "Condition",
    upgradeConditionPh: "Saisir la condition",
    riderCount: "Livreurs",
    peopleDetail: "Détail",
    nickname: "Pseudo",
    orderCount: "Commandes",
    levelN: "Niveau {n}",
  },
  health: {
    title: "Certificat sanitaire",
    frontImg: "Certificat (recto)",
    submitTime: "Date",
    auditStatus: "Statut",
    pending: "En attente",
    approved: "Approuvé",
    rejected: "Refusé",
    frontPhoto: "Photo recto",
    namePh: "Nom du livreur",
  },
  settings: {
    title: "Paramètres livreurs",
    orderCondition: "Conditions d'acceptation",
    realNameAuth: "Vérification d'identité",
    deposit: "Caution versée",
    orderConditionTip: "Remarque : le livreur doit être certifié avant d'accepter des commandes",
    pickUpCondition: "Conditions de retrait",
    none: "Aucune",
    pickUpCode: "Code de retrait",
    pickUpPhoto: "Photo de retrait",
    pickUpTip: "Une fois activé, le livreur doit téléverser une photo de retrait en magasin pour continuer",
    deliveryCondition: "Conditions de livraison",
    deliveryCode: "Code de livraison",
    deliveryPhoto: "Photo de livraison",
    deliveryTip: "Une fois activé, le livreur doit téléverser une photo de livraison pour continuer",
    orderRangeLimit: "Limite de zone d'acceptation",
    orderRangePh: "Saisir la limite de zone d'acceptation",
    withinKm: "km max",
    orderRangeTip: "Distance maximale pour accepter une commande, ex. 3 km autour de la position actuelle",
    arrivalDistanceLimit: "Limite de distance à l'arrivée",
    arrivalDistancePh: "Saisir la limite de zone d'acceptation",
    withinMeter: "m max",
    arrivalDistanceTip: "Distance au commerçant pour activer le bouton « Arrivé en magasin »",
    serviceDistanceLimit: "Limite de distance de livraison",
    serviceDistancePh: "Saisir la limite de distance de livraison",
    serviceDistanceTip: "Distance au client pour activer le bouton « Livré »",
    arrivalTimeLimit: "Limite de temps d'arrivée",
    enterKm: "Saisir les kilomètres",
    withinKmShort: "km",
    enterMinute: "Saisir les minutes",
    minuteComplete: "min pour terminer",
    afterKm: "km et plus",
    perKmAdd: "Par km +",
    minute: "min",
    serviceTimeLimit: "Limite de temps de livraison",
  },
  detail: {
    title: "Détail livreur",
    userUid: "UID : ",
    withdrawable: "Solde retirable",
    points: "Points",
    realName: "Nom réel",
    realNamePh: "Saisir le nom réel",
    riderAccount: "Compte livreur",
    riderAccountPh: "Saisir le compte",
    riderPassword: "Mot de passe",
    riderPasswordPh: "Saisir le mot de passe",
    wxAdmin: "Admin WeChat lié",
    wxAdminPh: "Admin WeChat lié",
    portrait: "Photo",
    regTime: "Date d'inscription",
    bindPhone: "Téléphone lié",
    bindPhonePh: "Saisir le téléphone",
    gender: "Genre",
    age: "Âge",
    agePh: "Saisir l'âge",
    urgentContact1: "Urgence 1",
    urgentContact1Ph: "Saisir le contact d'urgence 1",
    urgentContact2: "Urgence 2",
    urgentContact2Ph: "Saisir le contact d'urgence 2",
    homeAddress: "Adresse",
    homeAddressPh: "Saisir l'adresse",
    riderType: "Type",
    riderTypePh: "Choisir le type",
    fullTime: "Temps plein",
    partTime: "Temps partiel",
    riderLevel: "Niveau",
    idCard: "N° ID",
    idCardPh: "Saisir le N° ID",
    idCardPhoto: "Photo ID",
    idCardFront: "Recto ID",
    idCardBack: "Verso ID",
    bond: "Caution",
    unpaidBond: "Non versée",
    paidBond: "Versée",
    healthCert: "Certificat sanitaire",
    authStatus: "Certification",
    orderStats: "Statistiques commandes",
    totalOrders: "Commandes totales",
    totalTrips: "Trajets totaux",
    totalCommission: "Commission totale",
    complaintViolation: "Réclamations / infractions",
  },
  form: {
    addTitle: "Nouveau livreur",
  },
};
